// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../shared/Ui.re.mjs";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core from "@linaria/core";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

function GalleryList(props) {
  var moreText = "See more artistic style paintings";
  var moreLink = "/gallery/style-painting/";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: "Ordered by Customers",
                              className: Core.cx("text-2xl font-extrabold tracking-tight text-gray-900")
                            }),
                        JsxRuntime.jsxs(ReactRouterDom.Link, {
                              to: moreLink,
                              children: [
                                moreText,
                                JsxRuntime.jsx("span", {
                                      children: "→",
                                      "aria-hidden": true
                                    })
                              ],
                              className: Core.cx("hidden text-sm font-medium text-indigo-600 hover:text-indigo-500 md:block"),
                              reloadDocument: true
                            })
                      ],
                      className: Core.cx("md:flex md:items-center md:justify-between")
                    }),
                JsxRuntime.jsx("div", {
                      children: Belt_Array.map(props.items, (function (item) {
                              var params = item.image.imgixParams;
                              return JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: params !== undefined ? JsxRuntime.jsx(Ui.DImg.make, {
                                                          src: item.image.src,
                                                          alt: item.image.alt,
                                                          className: Core.cx("w-full h-full object-center object-cover lg:w-full lg:h-full"),
                                                          imgixParams: params,
                                                          breakpoints: {
                                                            default: "calc(100vw-(1rem*2))",
                                                            sm: "calc((640px - (1.5rem*3) - (1.5rem*2))/2)",
                                                            md: "calc((768px - (1.5rem*3) - (1.5rem*2))/2)",
                                                            lg: "calc((1024px - (1.5rem*3) - (2rem*2))/4)",
                                                            xl: "calc((1280px - (2rem*3) - (2rem*2))/4)",
                                                            xxl: "calc((1536px - (2rem*3) - (2rem*2))/4)"
                                                          }
                                                        }) : JsxRuntime.jsx(Ui.DImg.make, {
                                                          src: item.image.src,
                                                          alt: item.image.alt,
                                                          className: Core.cx("w-full h-full object-center object-cover lg:w-full lg:h-full"),
                                                          sizes: "(min-width: 1536px) calc((1536px - (2rem*3) - (2rem*2))/4),\n              (min-width: 1280px) calc((1280px - (2rem*3) - (2rem*2))/4),\n              (min-width: 1024px) calc((1024px - (1.5rem*3) - (2rem*2))/4),\n              (min-width: 768px) calc((768px - (1.5rem*3) - (1.5rem*2))/2),\n              (min-width: 640px) calc((640px - (1.5rem*3) - (1.5rem*2))/2),\n              calc(100vw-(1rem*2))"
                                                        }),
                                                  className: Core.cx("w-full min-h-80 h-40 bg-gray-200 aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 lg:h-60 lg:aspect-none")
                                                }),
                                            JsxRuntime.jsx("h3", {
                                                  children: JsxRuntime.jsxs(ReactRouterDom.Link, {
                                                        to: item.link,
                                                        children: [
                                                          JsxRuntime.jsx("span", {
                                                                "aria-hidden": true,
                                                                className: Core.cx("absolute inset-0")
                                                              }),
                                                          item.name
                                                        ],
                                                        className: Core.cx("mt-4 text-sm text-gray-700"),
                                                        reloadDocument: true
                                                      }),
                                                  className: Core.cx("mt-4 text-sm text-gray-700")
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: item.description,
                                                  className: Core.cx("mt-1 text-sm text-gray-500")
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "$" + String(item.price),
                                                  className: "mt-1 text-sm font-medium text-gray-900"
                                                })
                                          ],
                                          className: Core.cx("relative", "group")
                                        }, item.id);
                            })),
                      className: Core.cx("mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8")
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs(ReactRouterDom.Link, {
                            to: moreLink,
                            children: [
                              moreText,
                              JsxRuntime.jsx("span", {
                                    children: "→",
                                    "aria-hidden": true
                                  })
                            ],
                            className: Core.cx("font-medium text-indigo-600 hover:text-indigo-500"),
                            reloadDocument: true
                          }),
                      className: Core.cx("mt-8 text-sm md:hidden")
                    })
              ]
            });
}

var make = GalleryList;

export {
  make ,
}
/*  Not a pure module */
